import React, { useState } from "react";
import "./Navbar.css";
import { HashLink } from 'react-router-hash-link';

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const navClicked = () => {
    setMobileMenuOpen(false)
  }

  return (
    <nav className="navbar">
      <div className={`menu ${isMobileMenuOpen ? "active" : ""}`}>
        <HashLink smooth to="/#mission" className="menu-item" onClick={navClicked}>
          Mission
        </HashLink>
        <HashLink smooth to="/#investments" className="menu-item" onClick={navClicked}>
          Criteria
        </HashLink>
        <HashLink smooth to="/#values" className="menu-item" onClick={navClicked}>
          Values
        </HashLink>
        <HashLink smooth to="/#partnership" className="menu-item" onClick={navClicked}>
          Partnership
        </HashLink>
        <HashLink smooth to="/#contact" className="menu-item" onClick={navClicked}>
          Contact
        </HashLink>
      </div>
      <div className="hamburger" onClick={toggleMobileMenu}>
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </div>
    </nav>
  );
};

export default Navbar;
